import {
  type TiptapBulletList,
  type TiptapOrderedList,
  type TiptapListItem,
  type TiptapTextContent,
  type TiptapHeadingContent,
  type TiptapLinkMark,
  type TiptapMark,
  type TiptapStandardMark,
  type TiptapParagraphContent,
  type TiptapDocContent,
} from './types'
import { z } from 'zod'

const TiptapStandardMarkSchema: z.ZodType<TiptapStandardMark> = z.object({
  type: z.enum(['bold', 'underline', 'strike']),
})

const TiptapLinkMarkSchema: z.ZodType<TiptapLinkMark> = z.object({
  type: z.literal('link'),
  attrs: z.object({
    href: z.string(),
    rel: z.string(),
    target: z.string().or(z.literal(null)),
    class: z.string().or(z.literal(null)),
  }),
})

export const TiptapMarkSchema: z.ZodType<TiptapMark> = z.union([TiptapStandardMarkSchema, TiptapLinkMarkSchema])

export const TiptapTextSchema: z.ZodType<TiptapTextContent> = z.object({
  type: z.literal('text'),
  text: z.string(),
  marks: TiptapMarkSchema.array().optional(),
})

export const TiptapHeadingSchema: z.ZodType<TiptapHeadingContent> = z.object({
  type: z.literal('heading'),
  attrs: z.object({
    level: z.number().int().min(1).max(6),
  }),
  content: z.array(TiptapTextSchema),
})

export const TiptapParagraphSchema: z.ZodType<TiptapParagraphContent> = z.object({
  type: z.literal('paragraph'),
  content: z.array(TiptapTextSchema),
})

export const TiptapListItemSchema: z.ZodType<TiptapListItem> = z.object({
  type: z.literal('listItem'),
  content: z.lazy(() => z.array(z.union([TiptapBulletListSchema, TiptapOrderedListSchema, TiptapParagraphSchema]))),
})

export const TiptapBulletListSchema: z.ZodType<TiptapBulletList> = z.object({
  type: z.literal('bulletList'),
  content: z.array(TiptapListItemSchema),
})

export const TiptapOrderedListSchema: z.ZodType<TiptapOrderedList> = z.object({
  type: z.literal('orderedList'),
  attrs: z.object({
    start: z.number().int().min(1),
    type: z.literal(null),
  }),
  content: z.array(TiptapListItemSchema),
})

const TiptapDocContentSchema = z.array(
  z.union([TiptapBulletListSchema, TiptapOrderedListSchema, TiptapParagraphSchema, TiptapHeadingSchema])
)

export const TiptapDocSchema: z.ZodType<TiptapDocContent> = z.object({
  type: z.literal('doc'),
  content: TiptapDocContentSchema,
})
